// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex'
import * as VueGoogleMaps from 'vue2-google-maps'
import VModal from 'vue-js-modal'
import './assets/css/index.css'
import './assets/js/mixin'
import './assets/js/oauth'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBQsgo6QKEwuNAXm2NvxTOOiluvw0N2Gss',
    libraries: 'places'
  },
  installComponents: true
})

Vue.use(VModal)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  template: '<App/>',
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js